import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InternetLinkID from 'components/impfschaeden/assistent/VaxForm_06a_WieErfahren/components/InternetLinkID.js';
import {
	Col,
	DatePicker,
	DropdownSelect,
	FormGroup,
	FormText,
	Row,
	Stack,
} from 'components/ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const WieErfahren = ({ update, updateVaccination, formData, validation }) => {
	const globReferrers = useSelector((state) => state.masterData.globReferrers);
	const [t] = useTranslation();

	const getReferrerOptions = (referrers) => {
		let referrerOptions = [];
		if (Array.isArray(referrers)) {
			referrerOptions = referrers.map((referrer) => ({
				value: referrer.glob_referrer_id,
				text: t('master_data.referrer.' + referrer.referrer_i18n_key),
			}));
		}
		referrerOptions.unshift({
			value: '',
			text: t('common.bitte_waehlen') + ' *',
		});
		return referrerOptions;
	};

	const referrerOptions = getReferrerOptions(globReferrers);
	return (
		<>
			<Row xs={12} style={{ marginTop: '20px' }}>
				<Col xs={12} md={6}>
					<FormGroup className='mb-3' style={{ marginTop: '10px' }}>
						<Stack gap={3}>
							<DropdownSelect
								onChange={(e) => {
									update({
										glob_referrer_id: e.target.value,
									});
								}}
								value={formData.glob_referrer_id}
								isInvalid={validation['glob_referrer_id']}
								options={referrerOptions}
							/>
						</Stack>
					</FormGroup>
				</Col>
			</Row>
			{formData.glob_referrer_id == '1' && (
				<InternetLinkID
					formData={formData}
					update={update}
					updateVaccination={updateVaccination}
					validation={validation}
				/>
			)}

			{formData.glob_referrer_id == '1' && (
				<>
					<Row xs={12} style={{ marginTop: '20px' }}>
						<Col xs={12}>
							<FormText className='text-muted'>
								{t('common.datum_der_veroeffentlichung')}
							</FormText>
						</Col>
					</Row>
					<Row xs={12} style={{ marginTop: '5px' }}>
						<Col xs={12} md={12} className='d-flex align-items-center gap-4'>
							<DatePicker
								componentsProps={{
									actionBar: {
										actions: ['clear'],
									},
								}}
								onChange={(newValue) => {
									update({
										originally_posted_at:
											newValue?.format('YYYY-MM-DD') || null,
									});
								}}
								clearable={true}
								value={formData.originally_posted_at || null}
							/>
							<div
								className='cursor-pointer'
								onClick={() => {
									update({
										originally_posted_at: null,
									});
								}}
							>
								<FontAwesomeIcon icon={faTimes} />
							</div>
						</Col>
					</Row>
				</>
			)}
		</>
	);
};

WieErfahren.propTypes = {
	update: PropTypes.func,
	updateVaccination: PropTypes.func,
	formData: PropTypes.object,
	validation: PropTypes.object,
};

export { WieErfahren };
